import { Mail, Linkedin, Phone, Globe, Briefcase, Code2, Sparkles, Award, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const DKR_LOGO = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/hl7trfw4_1000867709.png";
const WAVE_LOGO = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/r28jxbfy_logo-wave.png";
const ORANGE_MONEY_LOGO = "https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/punl05bn_logo-orange-money.png";

export default function About() {
  const services = [
    { icon: Code2, title: "Développement d'applications", desc: "Web, mobile et SaaS sur mesure. React, FastAPI, MongoDB, Cloud." },
    { icon: Briefcase, title: "Conseil IT & Business Analysis", desc: "Cadrage produit, optimisation des processus, choix d'architecture." },
    { icon: Sparkles, title: "Solutions FinTech / Africa-first", desc: "Intégrations Wave, Orange Money & Maxit. UX adaptée au marché local." },
  ];

  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-amber-300/20 dark:bg-amber-500/10 blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-xs font-bold tracking-widest text-amber-600 dark:text-amber-400 uppercase">À propos</span>
              <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tighter mt-3 mb-6">
                Djiby <span className="gradient-text">NDIAYE</span>
              </h1>
              <p className="text-lg text-muted-foreground mb-4 leading-relaxed">
                Ingénieur informatique et Business Analyst, je conçois des produits numériques
                premium pour le Sénégal, l'Afrique et le monde francophone, à travers
                <span className="font-semibold text-foreground"> DKR Consulting</span>.
              </p>
              <p className="text-base text-muted-foreground leading-relaxed mb-8">
                Sen Cagnotte est né d'une conviction simple : la collecte de fonds devrait être aussi
                fluide qu'une conversation, aussi sécurisée qu'une banque, et aussi belle qu'un objet bien conçu.
              </p>

              {/* Contact list */}
              <div className="card-soft p-6 mb-8 space-y-3" data-testid="contact-card">
                <div className="flex items-center gap-3 text-sm">
                  <div className="h-9 w-9 rounded-lg gradient-gold-green flex items-center justify-center shrink-0">
                    <Phone className="h-4 w-4 text-white" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-muted-foreground">Téléphone</span>
                    <a href="tel:+33619446736" className="font-medium hover:text-primary" data-testid="contact-phone-fr">+33 619 44 67 36</a>
                    <a href="tel:+221778312002" className="font-medium hover:text-primary" data-testid="contact-phone-sn">+221 77 831 20 02</a>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <div className="h-9 w-9 rounded-lg gradient-gold-green flex items-center justify-center shrink-0">
                    <Mail className="h-4 w-4 text-white" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-muted-foreground">Email</span>
                    <a href="mailto:contact@dkr-consulting.com" className="font-medium hover:text-primary" data-testid="contact-email">contact@dkr-consulting.com</a>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <div className="h-9 w-9 rounded-lg gradient-gold-green flex items-center justify-center shrink-0">
                    <Globe className="h-4 w-4 text-white" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-muted-foreground">Site web</span>
                    <a href="https://www.dkr-consulting.com" target="_blank" rel="noreferrer" className="font-medium hover:text-primary" data-testid="contact-website">www.dkr-consulting.com</a>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <div className="h-9 w-9 rounded-lg gradient-gold-green flex items-center justify-center shrink-0">
                    <Linkedin className="h-4 w-4 text-white" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-muted-foreground">LinkedIn</span>
                    <a href="https://www.linkedin.com/in/djiby-ndiaye-11a92534/" target="_blank" rel="noreferrer" className="font-medium hover:text-primary" data-testid="contact-linkedin">linkedin.com/in/djiby-ndiaye</a>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-3">
                <a href="mailto:contact@dkr-consulting.com">
                  <Button className="btn-gradient rounded-full h-11" data-testid="about-email-btn">
                    <Mail className="h-4 w-4 mr-2" /> Me contacter
                  </Button>
                </a>
                <a href="https://www.linkedin.com/in/djiby-ndiaye-11a92534/" target="_blank" rel="noreferrer">
                  <Button variant="outline" className="rounded-full h-11 border-2" data-testid="about-linkedin-btn">
                    <Linkedin className="h-4 w-4 mr-2" /> LinkedIn
                  </Button>
                </a>
              </div>
            </div>

            {/* Right: DKR Consulting brand visual */}
            <div className="relative">
              <div className="relative aspect-square rounded-3xl overflow-hidden card-soft bg-white">
                <img src={DKR_LOGO} alt="DKR Consulting" className="w-full h-full object-contain p-12" data-testid="dkr-logo" />
              </div>
              <div className="mt-4 card-soft p-5 flex items-center gap-3">
                <Award className="h-5 w-5 text-amber-500 shrink-0" />
                <div>
                  <div className="text-xs font-bold tracking-widest uppercase">15+ ans d'expérience</div>
                  <p className="text-sm text-muted-foreground mt-1">Ingénieur informatique · Business Analyst · Entrepreneur</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-12">
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Services proposés</h2>
            <p className="text-muted-foreground mt-3">Des solutions construites avec soin, pour des projets qui durent.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {services.map((s, i) => (
              <div key={i} className="card-soft p-8 group" data-testid={`service-${i}`}>
                <div className="h-12 w-12 rounded-xl gradient-gold-green flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <s.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="font-display font-semibold text-xl mb-2">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>

          {/* Moyens de paiement supportés */}
          <div className="mt-16 max-w-3xl mx-auto text-center" data-testid="payments-section">
            <div className="text-xs font-bold tracking-widest text-amber-600 dark:text-amber-400 uppercase mb-3">Moyens de paiement</div>
            <h3 className="font-display text-2xl font-semibold mb-8">Wave & Orange Money — natifs Sénégal</h3>
            <div className="flex flex-wrap items-center justify-center gap-8">
              <div className="flex flex-col items-center gap-2">
                <img src={WAVE_LOGO} alt="Wave" className="h-20 w-20 sm:h-24 sm:w-24 object-contain rounded-2xl" />
                <span className="text-sm font-medium">Wave</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <img src={ORANGE_MONEY_LOGO} alt="Orange Money" className="h-20 w-20 sm:h-24 sm:w-24 object-contain rounded-2xl" />
                <span className="text-sm font-medium">Orange Money</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Parcours */}
      <section className="py-20 bg-secondary/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-12 text-center">Parcours</h2>
          <div className="space-y-6">
            {[
              { year: "Aujourd'hui", title: "Fondateur · Sen Cagnotte", desc: "Plateforme premium de cagnottes pour le Sénégal et l'Afrique francophone." },
              { year: "2020+", title: "Senior Business Analyst & Lead Dev · DKR Consulting", desc: "Pilotage de projets digitaux complexes : banque, télécom, e-commerce." },
              { year: "Avant", title: "Ingénieur informatique", desc: "Architecture logicielle, intégrations cloud, équipes pluridisciplinaires." },
            ].map((it, i) => (
              <div key={i} className="card-soft p-6 sm:p-8 flex gap-6">
                <div className="shrink-0 text-xs font-bold tracking-widest gradient-text uppercase pt-1">{it.year}</div>
                <div>
                  <h3 className="font-display font-semibold text-lg mb-1">{it.title}</h3>
                  <p className="text-sm text-muted-foreground">{it.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card-soft p-12 text-center">
            <h2 className="font-display text-3xl font-bold tracking-tight mb-3">Un projet en tête ?</h2>
            <p className="text-muted-foreground mb-6 max-w-xl mx-auto">Discutons de la manière de transformer votre idée en produit numérique remarquable.</p>
            <div className="flex flex-wrap justify-center gap-3">
              <Link to="/register">
                <Button className="btn-gradient rounded-full h-11 px-8" data-testid="about-cta-register">
                  Lancer ma cagnotte <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <a href="https://www.dkr-consulting.com" target="_blank" rel="noreferrer">
                <Button variant="outline" className="rounded-full h-11 px-8 border-2" data-testid="about-cta-dkr">
                  <Globe className="h-4 w-4 mr-2" /> Visiter DKR Consulting
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
